import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../../../assets/logo.png'
import _imports_1 from '@/assets/img/store/rating.svg'
import _imports_2 from '@/assets/img/store/download.svg'


const _hoisted_1 = { class: "bg-white p-[20px] font-sans" }
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = { class: "text-[22px] text-black text-opacity-80" }
const _hoisted_4 = { class: "hide-scrollbar mt-6 flex flex-nowrap overflow-x-auto whitespace-nowrap" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "mt-5" }
const _hoisted_7 = { class: "mt-5 flex" }
const _hoisted_8 = { class: "flex" }
const _hoisted_9 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  height: "13",
  viewBox: "0 96 960 960",
  width: "13"
}
const _hoisted_10 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  height: "13",
  viewBox: "0 96 960 960",
  width: "13"
}
const _hoisted_11 = {
  key: 0,
  class: "font-semibold"
}
const _hoisted_12 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StatusModal = _resolveComponent("StatusModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "mr-5 h-[56px] w-[56px]" }, [
        _createElementVNode("img", {
          src: _imports_0,
          class: "rounded-sm",
          alt: "icon"
        })
      ], -1)),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.appName), 1),
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "text-[14px] font-bold text-[#01875F]" }, " LLC Force Technologies ", -1))
      ])
    ]),
    _cache[11] || (_cache[11] = _createStaticVNode("<section class=\"mt-10 flex w-full\"><div class=\"flex flex-auto flex-col items-center border-r border-gray-400\"><div class=\"flex items-center text-black\"><div class=\"mr-1 font-bold text-opacity-80\">4.7</div><div class=\"h-[16px] w-[16px]\"><img src=\"" + _imports_1 + "\" alt=\"rating\"></div></div><div class=\"text-[12px] text-black text-opacity-60\">10 отзывов</div></div><div class=\"flex flex-auto flex-col items-center border-r border-gray-400\"><div class=\"font-bold text-black text-opacity-80\">100 тыс+</div><div class=\"text-[12px] text-black text-opacity-60\">Скачивания</div></div><div class=\"flex flex-auto flex-col items-center justify-center\"><div class=\"h-[18px] w-[18px]\"><img src=\"" + _imports_2 + "\" alt=\"rating\"></div><div class=\"mt-2 text-[12px] text-black text-opacity-60\">6.7МБ</div></div></section>", 1)),
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.sendPromt && _ctx.sendPromt(...args))),
      id: "storeBtn",
      class: "mt-7 flex justify-center rounded-lg bg-[#01875F] p-[8px] font-sans font-medium text-white"
    }, " Установить "),
    _createElementVNode("section", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mockupsLinks, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "mr-3 w-[60px] min-w-[120px]"
        }, [
          _createElementVNode("img", {
            class: "rounded-sm",
            src: item,
            alt: " image"
          }, null, 8, _hoisted_5)
        ]))
      }), 128))
    ]),
    _cache[12] || (_cache[12] = _createStaticVNode("<div class=\"mt-6\"><div class=\"text-lg text-black text-opacity-80\">Описание</div><div class=\"mt-2 text-sm text-black text-opacity-70\"> Моментальные выплаты за заказы Яндекс.Такси, Яндекс.Доставка. Сити мобил. </div><div class=\"mt-4 flex\"><div class=\"mr-3 rounded-full border border-gray-400 py-1 px-4 text-black text-opacity-80\"> Автомобили </div><div class=\"rounded-full border border-gray-400 py-1 px-4 text-black text-opacity-80\"> Бизнес </div></div></div>", 1)),
    _createElementVNode("div", _hoisted_6, [
      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "text-lg text-black text-opacity-80" }, "Оценки и отзывы", -1)),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("section", null, [
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "text-6xl text-black text-opacity-80" }, "4.5", -1)),
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (index) => {
              return _createElementVNode("div", {
                key: index + 100,
                class: "mr-[2px] mt-3 fill-[#01875F]"
              }, [
                (index != 5)
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_9, [...(_cache[4] || (_cache[4] = [
                      _createElementVNode("path", { d: "m196 1028 75-324L19 486l332-28 129-306 129 306 332 28-252 218 76 324-285-173-284 173Z" }, null, -1)
                    ]))]))
                  : (_openBlock(), _createElementBlock("svg", _hoisted_10, [...(_cache[5] || (_cache[5] = [
                      _createElementVNode("path", { d: "m323 851 157-94 157 95-42-178 138-120-182-16-71-168-71 167-182 16 138 120-42 178Zm-90 125 65-281L80 506l288-25 112-265 112 265 288 25-218 189 65 281-247-149-247 149Zm247-355Z" }, null, -1)
                    ]))]))
              ])
            }), 64))
          ]),
          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "mt-2 text-xs text-black text-opacity-70" }, "1,255", -1))
        ]),
        _cache[8] || (_cache[8] = _createStaticVNode("<section class=\"ml-10 flex w-full flex-col\"><div class=\"flex items-center\"><div class=\"mr-2 text-black text-opacity-80\">5</div><div class=\"h-[8px] w-full rounded-full bg-[#DBDBDB]\"><div class=\"h-full w-4/5 rounded-full bg-[#01875F]\"></div></div></div><div class=\"flex items-center\"><div class=\"mr-2 text-black text-opacity-80\">4</div><div class=\"h-[8px] w-full rounded-full bg-[#DBDBDB]\"><div class=\"h-full w-1/3 rounded-full bg-[#01875F]\"></div></div></div><div class=\"flex items-center\"><div class=\"mr-2 text-black text-opacity-80\">3</div><div class=\"h-[8px] w-full rounded-full bg-[#DBDBDB]\"><div class=\"h-full w-3/12 rounded-full bg-[#01875F]\"></div></div></div><div class=\"flex items-center\"><div class=\"mr-2 text-black text-opacity-80\">2</div><div class=\"h-[8px] w-full rounded-full bg-[#DBDBDB]\"><div class=\"h-full w-2/12 rounded-full bg-[#01875F]\"></div></div></div><div class=\"flex items-center\"><div class=\"mr-2 text-black text-opacity-80\">1</div><div class=\"h-[8px] w-full rounded-full bg-[#DBDBDB]\"><div class=\"h-full w-1/12 rounded-full bg-[#01875F]\"></div></div></div></section>", 1))
      ])
    ]),
    _createVNode(_component_StatusModal, {
      state: _ctx.modalState,
      type: "warning",
      "button-text": "Прочитал",
      onConfirm: _cache[1] || (_cache[1] = ($event: any) => (_ctx.modalState = false))
    }, {
      description: _withCtx(() => [
        (_ctx.isInstalled)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, " У вас уже установлено приложение. Найдите его в общем списке приложений "))
          : (_openBlock(), _createElementBlock("div", _hoisted_12, [...(_cache[10] || (_cache[10] = [
              _createElementVNode("div", { class: "font-semibold" }, " Установка приложения возможно только в браузере Google Chrome ", -1),
              _createElementVNode("div", { class: "underline mt-1 font-bold" }, [
                _createElementVNode("a", {
                  class: "text-blue",
                  href: "https://play.google.com/store/apps/details?id=com.android.chrome",
                  target: "_blank"
                }, "Открыть Google Chrome")
              ], -1)
            ]))]))
      ]),
      _: 1
    }, 8, ["state"])
  ]))
}